import Vue from "vue"
import Router from "vue-router"
const MainPage = () => import(/* webpackChunkName: "Main" */ "./views/MainPage.vue")
const NewsGuide = () => import(/* webpackChunkName: "NewsGuide" */ "./views/NewsGuide.vue")
const PolicyTerms = () => import(/* webpackChunkName: "PolicyTerms" */ "./views/PolicyTerms.vue")
const PolicyPrivacy = () => import(/* webpackChunkName: "PolicyPrivacy" */ "./views/PolicyPrivacy.vue")
const NotFound = () => import(/* webpackChunkName: "PolicyPrivacy" */ "./views/NotFound.vue")

Vue.use(Router)

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/news/guide",
      name: "guide",
      component: NewsGuide
    },
    {
      path: "/news/tip",
      name: "tip",
      component: NewsGuide
    },
    {
      path: "/news",
      name: "news",
      component: MainPage
    },
    {
      path: "/",
      name: "root",
      component: MainPage
    },
    {
      path: "/policy/terms",
      name: "terms",
      component: PolicyTerms
    },
    {
      path: "/policy/privacy",
      name: "privacy",
      component: PolicyPrivacy
    },
    {
      path: "/404",
      name: "404",
      component: NotFound
    },
    {
      path: "/*",
      // component: NotFound
      component: MainPage
    }
  ],
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  }
})
router.beforeEach((to, from, next) => {
  if (to.fullPath.includes("blog")) {
    window.location.href = "/blog/index.html"
    return
  }
  // INFO: NaverApp에서 링크를 사용하고 있어서 확인중
  // https://signal-z9i9638.slack.com/archives/C01G3FL8KDX/p1677967908217879
  // const isQuersyStringPath = !to.query || !!Object.keys(to.query).length
  // if (isQuersyStringPath) {
  //   next({ name: "404" })
  //   return
  // }
  gtag("event", "route", {
    event_category: "page",
    event_label: to.path
  })
  next()
})

export default router
